import { Tools } from "domains/home/components/SectionTools";
import { TOP_BAR_HEIGHT } from "domains/navigation/constants/TopBar";
import Button, { ButtonProps, IconButton } from "domains/ui/components/Button";
import Divider from "domains/ui/components/Divider";
import Icon from "domains/ui/components/Icon";

import {
  Box,
  Drawer,
  DrawerContent,
  DrawerOverlay,
  HStack,
  Text,
  VStack,
} from "@chakra-ui/react";

interface NavDrawerProps {
  isOpen: boolean;
  onClose: () => void;
}

/**
 * This is the side navigation drawer for mobile and smaller screens
 */
export default function NavDrawer({ isOpen, onClose }: NavDrawerProps) {
  return (
    <Drawer isOpen={isOpen} onClose={onClose} placement="left">
      <DrawerOverlay backdropFilter="blur(30px)" bgColor="rgba(0, 0, 0, 0.1)" />
      <DrawerContent
        overflow="auto"
        w="90vw"
        maxW="90vw"
        h="100vh"
        pb={6}
        px={4}
        bgColor="background.500"
      >
        <Box
          pos="sticky"
          zIndex="sticky"
          top={0}
          w="full"
          bgColor="background.500"
        >
          <HStack w="full" h={`${TOP_BAR_HEIGHT}px`} mx={-2}>
            <IconButton
              aria-label="Close"
              variant="ghost"
              colorScheme="white"
              onClick={onClose}
            >
              <Icon id="Ui/CrossSm" h="12px" />
            </IconButton>
          </HStack>
        </Box>

        <VStack align="stretch" w="full" py={0}>
          <MainMenuItem internalLink="/" onClick={onClose}>
            Home
          </MainMenuItem>

          <MainMenuItem internalLink="/assets" onClick={onClose}>
            Assets
          </MainMenuItem>

          <MainMenuItem internalLink="/explore" onClick={onClose}>
            Explore
          </MainMenuItem>

          <MainMenuItem
            externalLink="https://help.scenario.com"
            onClick={onClose}
          >
            Learn
          </MainMenuItem>

          <MainMenuItem internalLink="/collections" onClick={onClose}>
            Collections
          </MainMenuItem>
        </VStack>

        <Divider my={6} />

        <VStack align="stretch" w="full" spacing={4}>
          <Text color="textPrimary" size="body.bold.lg">
            Create
          </Text>

          <Tools isCompact context="topbar" onButtonClick={onClose} />
        </VStack>
      </DrawerContent>
    </Drawer>
  );
}

// ------------------------------------

type MainMenuItemProps = ButtonProps;

function MainMenuItem(props: MainMenuItemProps) {
  return (
    <Button
      size="sm"
      variant="alpha"
      rightIcon={<Icon id="Ui/ChevronRight" h="12px" />}
      justifyContent="space-between"
      color="white"
      fontWeight="600"
      h="40px"
      px={4}
      {...props}
    />
  );
}
